"use strict";

exports.__esModule = true;
var _NotificationsIcon = require("./NotificationsIcon");
Object.keys(_NotificationsIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotificationsIcon[key]) return;
  exports[key] = _NotificationsIcon[key];
});
var _NotificationsIconContext = require("./NotificationsIconContext");
Object.keys(_NotificationsIconContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotificationsIconContext[key]) return;
  exports[key] = _NotificationsIconContext[key];
});